import EnterpriseApiService from "src/api/EnterpriseApiService";
import { queryOptions } from "./v4QueryOptions/queryOptions"

export const getAllIotDevicesQueryOptions = () => {
    return queryOptions({
        queryKey: ["getAllIotDevices"],
        enabled: true,
        refetchOnWindowFocus: false,
        queryFn: async (q) => {

            return await EnterpriseApiService.getAllIotDevices(q.signal);
        }
    });
}